/**
 * Class description
 *
 * Created: 2019-08-29
 * @author jonas
 */
import {
    Timeline,
    TimelineLite,
    TweenLite
} from "gsap";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {HarlequinSoundConfig} from "../../HarlequinSoundConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";

export class BigWinStart implements GameRoundPresentation {
    stagger?:number;
    abortStagger?:number;

    constructor(stagger?:number, abortStagger?:number) {
        this.stagger = stagger;
        this.abortStagger = abortStagger;
    }

    public prepare(data:ParsedServerData):void {

    }

    public getAnimation(data:ParsedGameData):Timeline | null {
        if (!data.isBigWin){
            return  null;
        }
        const tl:TimelineLite = new TimelineLite();

        tl.add([
            () => {
                //SlotGame.sound.playEffect(HarlequinSoundConfig.instance.BIG_WIN, 1000);
            },
            () => {
                //SlotGame.sound.playEffect(HarlequinSoundConfig.instance.BIG_WIN_COUNTUP, 1000);
            }
        ], 0);


        return tl;
    }

    public abort(isActive:boolean, data:ParsedServerData):Timeline | null {

        return null;
    }

}